import { WET_WELL_TAG_NAME } from 'src/features';
import { AssetType } from 'src/types/assets';
import { useGetLatestGatewayReadings } from 'src/hooks/useGetLatestGatewayReadings';

type Props = {
  asset: AssetType | undefined;
};

export const useData = ({ asset }: Props) => {
  const waterTowerAsset = asset?.assignedTags?.find(
    (tag) => tag?.tagName?.toLowerCase() === WET_WELL_TAG_NAME
  );

  const assignedTagId = waterTowerAsset?.assignedTagId;
  const gatewayId = waterTowerAsset?.assignedGatewayId;

  const { readings: latestReadings } = useGetLatestGatewayReadings({
    gatewayId: gatewayId,
    tagId: assignedTagId,
  });

  const readingsRawInputName = assignedTagId && latestReadings[assignedTagId];
  const readingsValues = readingsRawInputName?.values;
  const readingValueList = readingsValues && Object.values(readingsValues);
  const readingValue = readingValueList && readingValueList[0];

  return { readingValue };
};
